import { VStack, Skeleton, Text, Box } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { useTranslation } from 'react-i18next';

import NoMaterials from '@/assets/images/originals/no-materials.svg';

import { Carousel } from '@/components/ui/shared/carousel-originals/Carousel';
import { SlugIdParam, useQueryParams } from '@/hooks/useQueryParams';
import { getMaterialsForSeries } from '@/queries/originals-materials';
import { OriginalsMaterial } from '@/resources/OriginalsMaterial';

export const MaterialsCarousel = () => {
  const { t } = useTranslation();
  const { id: seriesId } = useQueryParams<{ id: string }>({
    id: SlugIdParam,
  });
  const { data, error } = useResources(getMaterialsForSeries(seriesId));
  const isLoading = data === undefined;
  const isEmpty = data?.length === 0;

  if (error) {
    throw error;
  }

  if (isLoading) {
    return <Skeleton w={{ base: '240px', md: '288px' }} h="264px" />;
  }

  if (isEmpty) {
    return (
      <VStack maxW="240px">
        <NoMaterials />
        <Text fontSize="md" lineHeight="short" align="center" color="gray.300">
          {t('episodeMaterial.noMaterials')}
        </Text>
      </VStack>
    );
  }

  return (
    <Box alignSelf="end">
      <Carousel materials={data as Array<OriginalsMaterial>} />
    </Box>
  );
};
